<template>
    <div>
        <Breadcrumb style="position: relative;margin:0;"></Breadcrumb>
        <div class="info-wrapper default">
            <div class="detail-img-wrapper mb-3">
                <img src="@/assets/instruction_img.jpg" alt="" />
            </div>
            <div class="detail-card green">
                <div class="card-body">
                    <div class="title mb-2">雨水花園</div>
                    <p class="html-wrapper">
                        將雨水集中，藉由植栽之根系過濾、沉降逕流中懸浮固體及沉積物，再入滲土壤之設施。
                        <br /><br />
                        1
                        通過滯蓄削減洪峰流量、減少雨水外排保護下游管道、構築物和水體；<br />
                        2 利用植物截流、土壤滲濾淨化雨水、減少污染；<br />
                        3
                        充分利用徑流雨量涵養地下水，也可對處理後的雨水加以收集利用，緩解水資源的短缺；<br />
                        4
                        經過合理的設計以及妥善的維護能改善小區的環境，為鳥類、蝴蝶等動物提供食物和棲息地，提升生物物種多樣性；<br />
                        5
                        通過花園中植物的蒸騰作用可以調節環境中空氣的濕度與溫度，改善小氣候環境。
                    </p>
                    <button class="btn btn-more w-100 d-block my-3">
                        語音導覽
                    </button>
                    <button class="btn btn-more w-100 d-block my-3">
                        如何抵達
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [require('@/assets/instruction_img.jpg')],
        };
    },
    components: {
        Breadcrumb,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
